import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { MotifButton, MotifFormField, MotifLabel, MotifSelect, MotifOption } from "@ey-xd/motif-react";
import Input from '../../../common/components/Input/Input';
import './AddFinding.scss';
import ReportTypeImg from '../../../assets/media/images/report_type.png'
import { MotifInput } from '@ey-xd/motif-react';
import { MotifIcon } from '@ey-xd/motif-react';
import { contentIcAdd24px } from '@ey-xd/motif-react/assets/icons';
import { createFinding } from '../../../redux/actions/SideBar/sideBar';
import { MotifProgressLoader } from '@ey-xd/motif-react';

const AddFinding = ({
    setShowFindingForm,
    setShowAddFinding

}: any) => {
    const dispatch =  useDispatch()
    const reportInfo =  useSelector((state: any) => state.sideBar.reportInfo);
    const [showSpinner, setShowSpinner] = useState(false);

    const moveToFindingPage = () => {
        setShowSpinner(true);
        dispatch(createFinding({
            "report_id":reportInfo?.reportId,
            "report_state":"draft"
        })).then(() => {
            setShowSpinner(false)
        })
        setShowAddFinding(false);
        setShowFindingForm(true);
    }
    return (
        <div className='clientDetails'>
            <MotifProgressLoader show={showSpinner}/>
            <img src={ReportTypeImg} />
            <div className="clientDetails__title">Start Adding Findings</div>
            <div >Start adding findings to begin building your report.</div>
            <div style={{ display: 'flex', justifyContent: 'center', marginTop: "20px" }}>
                <MotifButton size="medium" variant="primary" onClick={() => moveToFindingPage()}>
                    <MotifIcon src={contentIcAdd24px} />
                    Add Finding
                </MotifButton>
            </div>
        </div>
    )

}

export default AddFinding;